module.exports = __webpack_public_path__ + "static/media/avatar_like_zoom.8ec10c65.png";